import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=994114dc&scoped=true&lang=pug&"
import script from "./overlay.vue?vue&type=script&lang=ts&"
export * from "./overlay.vue?vue&type=script&lang=ts&"
import style0 from "./overlay.vue?vue&type=style&index=0&id=994114dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994114dc",
  null
  
)

export default component.exports